import { getAddressBookBridgeContract } from "createProposal/constants/address-book-bridge-contracts"
import { getAddressBookContract } from "createProposal/constants/address-book-contracts"

export const getContractNameFromAddressBook = (
  governorId: string,
  targetAddress: string,
): string | undefined => {
  const contract = getAddressBookContract(governorId, targetAddress)

  if (contract) {
    return contract.name
  }

  const bridgeAction = getAddressBookBridgeContract(governorId, targetAddress)

  if (bridgeAction) {
    return bridgeAction.name
  }

  return undefined
}
